<template>
    <v-container>
      <div class="mt-10">
      <CRUDList class="mt-10" ref="crudList"
      toolbarTitle="Tax Roll" :canAdd="false" :canEdit="false" :canSave="true"
        :showSelect="false" :enableFixedHeaders="true"
        :displayTopPagination="false" :headers="headers"
        :baseCrudKey="baseCrudKey"
        tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='200'
        :defaultSortBy="defaultSortBy"
        :selectedItems="selectedItems"
        @emitSelectedItem="taxWarrantSelectedItem"
        @loadCRUDList = "handleLoadCrudList" >
      </CRUDList>
      <template>
      </template>
    </div>
    </v-container>

  </template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import '../../../../assets/style.css';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import { taxStatusCodesHeader } from '../../../shared/Utils/taxHeaders.utils';

export default {
  name: 'delinquentTaxBrowse',
  data() {
    return {
      baseCrudKey: 'DelinquentTaxBrowse',
      headers: taxStatusCodesHeader,

    };
  },
  components: {
    CRUDList,

  },

  computed: {
    ...mapGetters('base/crud', ['item']),
    ...mapGetters('base/crud', [
      'criteria',
    ]),

    ...mapState({
      StoreSelItems: (state) => state.tax.taxWarrants.selectedItems,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [{
        column: 'statusCode',
        direction: 'asc',
      }];
    },
  },
  methods: {
    ...mapMutations('tax/taxWarrants', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
      'upserttaxStatusCodes',
      'deleteTaxStatusCode',
    ]),
    taxWarrantSelectedItem(id) {
      this.selectedItems = id;
    },
    ...mapMutations('base/crud', [
      'setCriteria', 'setItems',
    ]),

    handleLoadCrudList() {
      const { baseCrudKey } = this;

      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
        isTaxWarrant: true,
      };
      this.loadTaxStatusCodesSharedRecords(
        {
          criteria,
          baseCrudKey,
        },
      );
    },

  },
};
</script>

  <style scoped>
  .label {
    font-size: 0.85rem;
  }
  </style>
